import {Tooltip} from "react-tooltip";
import styles from "../report.module.scss";
import {TUrlImportItem} from "mapx-components/BulkImport/types";
import {withImportErrorReason} from "helpers/importErrorReason";

const ImportReportTooltip = (props: TUrlImportItem) => {
	function capitalizeFirstWord(str: string) {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}

	return (
		<Tooltip id={props.url} place="top" delayShow={0} className={styles.toolTip}>
			{props.reason && props.status.toLowerCase() !== "bad url" && (
				<p style={{maxWidth: "300px"}}>{capitalizeFirstWord(props.reason)}</p>
			)}

			{props.status.toLowerCase() === "bad url" && (
				<p style={{maxWidth: "300px"}}>This URL is invalid. Please check again</p>
			)}

			{!props.reason &&
				(props.status.toLowerCase() === "scraping error" ||
					props.status.toLowerCase() === "import error") && (
					<p style={{maxWidth: "300px"}}>
						{withImportErrorReason(
							"This profile could not be processed",
							props.error_reason,
						)}
					</p>
				)}

			{!props.reason && props.status.toLowerCase() === "not found" && (
				<p style={{maxWidth: "300px"}}>This profile was not found</p>
			)}
		</Tooltip>
	);
};

export default ImportReportTooltip;
